var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16.017,
    viewBox: "0 0 16.001 16.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_contratto",
    "data-name": "icona contratto",
    transform: "translate(-13.245 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_895",
    "data-name": "Tracciato 895",
    d: "M25.846,15.238s-11.381.262-11.76,0-.183-10.477,0-10.666a25.675,25.675,0,0,1,3.82,0,.4.4,0,0,0,.42-.381,19.848,19.848,0,0,1,0-3.428c.2-.18,7.382-.261,7.52,0a6.464,6.464,0,0,1,0,1.642c.019,0,.037-.006.056-.007a2.244,2.244,0,0,1,.6.069c.056.013.119.032.184.052V1.381C26.683-.156,25.5,0,25.266,0h-7.4a.444.444,0,0,0-.3.111l-4.2,3.81a.363.363,0,0,0-.123.269V14.619A1.254,1.254,0,0,0,14.666,16h10.6c1.6.156,1.42-1.17,1.42-1.381V9.713a1.326,1.326,0,0,1-.84.324,42.144,42.144,0,0,1,0,5.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_896",
    "data-name": "Tracciato 896",
    d: "M244.089,42.133a.764.764,0,0,0-.5-.24.134.134,0,0,0-.085.034l-.955.866a2.5,2.5,0,0,1,.452.33,2.363,2.363,0,0,1,.364.41l.954-.866a.111.111,0,0,0,.038-.077A.638.638,0,0,0,244.089,42.133Z",
    transform: "translate(-215.107 -39.541)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_897",
    "data-name": "Tracciato 897",
    d: "M91.581,59.288l-.462.419-.307-.278.826-.749a.353.353,0,0,0,.118-.243A2.006,2.006,0,0,0,90.925,57a2.408,2.408,0,0,0-1.586-.754.427.427,0,0,0-.267.107l-7.129,6.465a.355.355,0,0,0-.1.143l-1,2.716a.342.342,0,0,0,.1.375.431.431,0,0,0,.412.088l2.995-.906a.429.429,0,0,0,.157-.087L90.515,59.7l.307.278L88.9,61.716a.357.357,0,0,0,0,.539.451.451,0,0,0,.594,0l2.678-2.429a.356.356,0,0,0,0-.539A.451.451,0,0,0,91.581,59.288Z",
    transform: "translate(-63.399 -53.087)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.ed82c1b93fdb49c661d15673634493cf.svg";
export { ForwardRef as ReactComponent };